import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ListItem } from '@lmnop/web-core';
import { ControlContainer, FormGroupDirective } from '@angular/forms';
import { ControlBase } from '../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';
declare var $: any;

@Component({
    selector: 'multiselect-extended-control',
    templateUrl: 'multiselect-extended.control.html',
    standalone: false,
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
})
export class MultiselectExtendedControl extends ControlBase {
    public dropdownSettings: any;

    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    @Input() controlName!: string;
    @Input() data: ListItem[] = [];
    @Input() inputId: string = '';

    @Input() parentFormHelper!: {
        showFieldError(controlName: string): boolean;
        getErrorMessageHtml(controlName: string): string;
    };

    public ngAfterViewInit(): void {
        this.initMultiSelect();
    }

    private initMultiSelect() {
        this.dropdownSettings = {
            singleSelection: false,
            idField: 'value',
            textField: 'text',
            itemsShowLimit: 3,
            allowSearchFilter: true,
            defaultOpen: false,
        };
    }

    @Output() selectionChange = new EventEmitter<any>();

    onChange(event: Event) {
        const value = (event.target as HTMLSelectElement).value;
        this.selectionChange.emit(value);
    }
}
